'use strict';

/* globals config, $ */

require([config.relative_path + '/plugins/nodebb-plugin-courses/static/vendor/vue.js'], function (Vue) {
	var internals = {};

	Vue.component('course-trainers-panel', {
		props: ['initData'],
		data: function () {
			return {
				trainers: this.initData.trainers,
			};
		},
		mounted: function () {

		},
		methods: {
			addTrainer: function () {
				var trainer = { name: '', image: null, video: null, videoThumbnail: null };

				this.trainers.push(trainer);

				internals.expandTrainer(trainer);
			},
			removeTrainer: function (trainer) {
				var index = this.trainers.indexOf(trainer);

				if (index > -1) {
					this.trainers.splice(index, 1);
				}
			},
		},
		template:
		'<div>' +
			'<button type="button" class="btn btn-primary mb-4" v-on:click="addTrainer()">{{initData.translations.addTrainer}}</button>' +
			'<div class="panel-group" id="trainers" role="tablist" aria-multiselectable="true">' +
				'<trainer-edit v-for="(trainer, index) in trainers" :index="index" :init-data="initData" :trainer="trainer" :remove-trainer="removeTrainer"></trainer-edit>' +
			'</div>' +
		'</div>',
	});

	internals.expandTrainer = function (trainer) {
		setTimeout(function () {
			$('[data-toggle="collapse"]', trainer.el).click();
		}, 150);
	};
});
